<template>
  <div class="mot-de-passe-oublie" data-model-id="3:5033">
    <div class="reset-container">
      <div class="reset-content">
        <div class="logo-section">
          <RouterLink to="/">
            <img
              class="logo"
              alt="Florisuite Logo"
              src="https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
            />
          </RouterLink>
        </div>

        <div class="form-section">
          <div class="form-header">
            <h1 class="form-title">Mot de passe oublié ?</h1>
            <p class="form-subtitle">
              Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
            </p>
          </div>

          <form class="reset-form" @submit.prevent="handleReset">
            <div class="form-group">
              <label class="form-label" for="email">Email</label>
              <input
                class="form-input"
                type="email"
                id="email"
                placeholder="votre.email@exemple.com"
                required
              />
            </div>

            <button class="submit-button" type="submit">
              <span class="button-text">Envoyer le lien de réinitialisation</span>
            </button>
          </form>

          <div class="back-to-login">
            <RouterLink to="/connexion" class="back-link">
              <img class="arrow-icon" alt="Arrow" src="https://c.animaapp.com/nNxA75tB/img/arrow-left.svg" />
              <span>Retour à la connexion</span>
            </RouterLink>
          </div>
        </div>

        <div class="info-section">
          <div class="info-card">
            <img class="info-icon" alt="Info" src="https://c.animaapp.com/nNxA75tB/img/info.svg" />
            <div class="info-content">
              <h3 class="info-title">Besoin d'aide ?</h3>
              <p class="info-text">
                Si vous ne recevez pas l'email dans les 5 minutes, vérifiez votre dossier spam ou
                <a href="/contact" class="contact-link">contactez notre support</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { RouterLink } from "vue-router";

export default defineComponent({
  name: "MotDePasseOublie",
  components: {
    RouterLink,
  },
  methods: {
    handleReset() {
      alert("Email de réinitialisation envoyé ! (Démo uniquement)");
    },
  },
});
</script>

<style>
.mot-de-passe-oublie {
  align-items: center;
  background: linear-gradient(135deg, rgba(250, 250, 250, 1) 0%, rgba(247, 252, 243, 1) 100%);
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px;
  position: relative;
  width: 100%;
}

.mot-de-passe-oublie .reset-container {
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 600px;
  width: 100%;
}

.mot-de-passe-oublie .reset-content {
  align-items: center;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 48px;
  padding: 60px 48px;
  width: 100%;
}

.mot-de-passe-oublie .logo-section {
  align-self: center;
}

.mot-de-passe-oublie .logo {
  height: 40px;
  width: auto;
}

.mot-de-passe-oublie .form-section {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

.mot-de-passe-oublie .form-header {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mot-de-passe-oublie .form-title {
  align-self: stretch;
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
}

.mot-de-passe-oublie .form-subtitle {
  align-self: stretch;
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
}

.mot-de-passe-oublie .reset-form {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.mot-de-passe-oublie .form-group {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.mot-de-passe-oublie .form-label {
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 20px;
}

.mot-de-passe-oublie .form-input {
  align-self: stretch;
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  box-sizing: border-box;
  color: #1a1a1a;
  font-family: "Open Sans", Helvetica;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 24px;
  padding: 12px 16px;
  transition: border-color 0.2s ease;
  width: 100%;
}

.mot-de-passe-oublie .form-input:focus {
  border-color: #084734;
  outline: none;
}

.mot-de-passe-oublie .form-input::placeholder {
  color: #9ca3af;
}

.mot-de-passe-oublie .submit-button {
  all: unset;
  align-self: stretch;
  background-color: #084734;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  cursor: pointer;
  height: 48px;
  overflow: hidden;
  padding: 12px 32px;
  position: relative;
  text-align: center;
  transition: all 0.2s ease;
}

.mot-de-passe-oublie .submit-button:hover {
  background-color: #0a5a42;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
}

.mot-de-passe-oublie .button-text {
  color: #ffffff;
  font-family: "Open Sans", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.mot-de-passe-oublie .back-to-login {
  align-items: center;
  align-self: stretch;
  display: flex;
  justify-content: center;
}

.mot-de-passe-oublie .back-link {
  align-items: center;
  color: #084734;
  display: flex;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  letter-spacing: 0;
  line-height: 20px;
  text-decoration: none;
}

.mot-de-passe-oublie .back-link:hover {
  text-decoration: underline;
}

.mot-de-passe-oublie .arrow-icon {
  height: 16px;
  width: 16px;
}

.mot-de-passe-oublie .info-section {
  align-self: stretch;
  width: 100%;
}

.mot-de-passe-oublie .info-card {
  align-items: flex-start;
  background-color: #f1faea;
  border-left: 4px solid #084734;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  padding: 20px;
}

.mot-de-passe-oublie .info-icon {
  flex-shrink: 0;
  height: 24px;
  margin-top: 2px;
  width: 24px;
}

.mot-de-passe-oublie .info-content {
  align-items: flex-start;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;
}

.mot-de-passe-oublie .info-title {
  color: #1a1a1a;
  font-family: "Montserrat", Helvetica;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.mot-de-passe-oublie .info-text {
  color: #5f5f5f;
  font-family: "Open Sans", Helvetica;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 20px;
}

.mot-de-passe-oublie .contact-link {
  color: #084734;
  font-weight: 600;
  text-decoration: none;
}

.mot-de-passe-oublie .contact-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .mot-de-passe-oublie .reset-content {
    padding: 40px 32px;
  }
}
</style>
